module.exports = __webpack_public_path__ + "static/media/reformer8.820ea30b.jpg";